<template>
    <div class="searching">
        <!-- 页面头部 -->
        <PageHeader></PageHeader>

        <!-- 搜索框 -->
        <van-search v-model="searchValue" placeholder="请输入搜索内容" show-action shape="round" @input="getsearchValue" @keyup.enter="onSearch">
            <div slot="action" @click="onSearch" @keyup.enter="onSearch">搜索</div>
        </van-search>

        <!-- 自动补全框 -->
        <ul class="auto-keywords" v-if="searchValue">
            <li v-for="(item, index) in autoSearchKeywords" :key="index" @click="onClickAutoLi(item)"><van-icon name="orders-o" size="1.2em" />{{ item }}</li>
        </ul>

        <!-- 搜索热词 -->
        <div class="search-title">
            <h3>搜索热词</h3>
            <div class="more" @click="getMoreHotSearch">
                <span>查看更多</span><span><van-icon name="arrow"/></span>
            </div>
        </div>
        <ul class="search-recommend">
            <SearchHotRecommend v-for="(item, index) in hotWords" :key="index" :item="item" @onClickHotSearch="getClickHotSearchIndex(index)"></SearchHotRecommend>
        </ul>

        <!-- 热门推荐 -->
        <div class="search-title">
            <h3>热门推荐</h3>
            <div class="more" @click="changeBatch">
                <span>换一批</span><span><van-icon name="replay"/></span>
            </div>
        </div>
        <ul class="hot-recommend">
            <HotRecommend v-for="(item, index) in hotRecommends" :key="index" :item="item" @onClickHotRecommend="getClickHotRecommendWord($event)"></HotRecommend>
        </ul>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import SearchHotRecommend from "@/components/SearchHotRecommend.vue";
import HotRecommend from "@/components/HotRecommend.vue";

export default {
    data() {
        return {
            searchValue: null,
            hotWords: null,
            hotRecommends: null,
            hotRecommendAll: null,
            hotRecommendsLen: null,
            autoSearchKeywords: null
        };
    },
    components: {
        PageHeader,
        SearchHotRecommend,
        HotRecommend
    },
    computed: {
        getsearchValue: function() {
            this.$store.commit("getAutoSearchWords", {
                value: this.searchValue
            });
            return this.getAutoComplete();
        }
    },
    methods: {
        onClickAutoLi(word) {
            this.searchValue = word;
            this.onSearch();
        },
        getClickHotRecommendWord(word) {
            this.searchValue = word;
            this.onSearch();
        },
        getClickHotSearchIndex(index) {
            // window.console.log("xx");
            this.searchValue = this.hotWords[index];
            this.onSearch();
        },
        onSearch() {
            if (this.searchValue !== null) {
                window.console.log("click");
                this.$store.commit("getSearchResult", {
                    value: this.searchValue
                });
                this.$router.push({
                    path: "/search",
                    query: {
                        keyword: this.searchValue
                    }
                });
            }
        },
        getAutoComplete() {
            let searchValue = localStorage.getItem("searchValue");
            if (searchValue && Date.now() < JSON.parse(searchValue).time + 60 * 60 * 1000) {
                this.searchValue = JSON.parse(searchValue).data;
            } else {
                this.axios
                    .get("https://novel.kele8.cn/auto-complete", {
                        params: {
                            query: this.searchValue
                        }
                    })
                    .then(response => {
                        window.console.log(response.data);
                        this.autoSearchKeywords = response.data.keywords;
                    });
            }
        },
        getMoreHotSearch() {
            this.$router.push({ path: "/Searchhotword" });
        },
        changeBatch() {
            let num = Math.floor(Math.random() * this.hotRecommendsLen - 8);
            this.hotRecommends = this.hotRecommendAll.slice(num, num + 6);
        }
    },
    beforeRouteEnter(to, from, next) {
        // ...
        next(vm => {
            // 通过 `vm` 访问组件实例
            vm.axios.get("https://novel.kele8.cn/hot-books").then(response => {
                window.console.log(response.data);
                ({ hotWords: vm.hotWords } = response.data);
                localStorage.setItem(
                    "hotWords",
                    JSON.stringify({
                        time: Date.now(),
                        data: vm.hotWords
                    })
                );
            });
            vm.axios.get("https://novel.kele8.cn/search-hotwords").then(response => {
                window.console.log(response.data);
                ({ searchHotWords: vm.hotRecommendAll } = response.data);
                vm.hotRecommendsLen = response.data.searchHotWords.length;
                vm.hotRecommends = vm.hotRecommendAll.slice(0, 6);
                localStorage.setItem(
                    "hotRecommends",
                    JSON.stringify({
                        time: Date.now(),
                        data: vm.hotRecommends
                    })
                );
            });
        });
    }
};
</script>

<style lang="less">
.searching {
    position: relative;
    .van-icon {
        top: 2px;
    }
    form {
    }
    ul.auto-keywords {
        position: absolute;
        top: 100px;
        left: 0;
        width: 100%;
        height: 100vh;
        padding: 0 10px;
        background: #ffffff;
        z-index: 99;
        box-sizing: border-box;
        & > li {
            border-bottom: 1px solid rgb(243, 243, 243);
            line-height: 50px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            .van-icon {
                margin-right: 5px;
                top: 4px;
            }
        }
    }
    .search-title {
        padding: 0 10px;
        &::after {
            content: "";
            display: block;
            clear: both;
        }
        h3 {
            display: inline-block;
            font-size: 18px;
        }
        .more {
            line-height: 60px;
            float: right;
            font-size: 12px;
        }
    }
    ul.search-recommend {
        padding: 0 10px;
        &::after {
            content: "";
            display: block;
            clear: both;
        }
        & > li {
            float: left;
            border: 1px solid #666;
            border-radius: 15px;
            margin: 5px 5px;
            padding: 2px 8px;
            font-size: 14px;
            color: #666;
            &:nth-child(n + 7) {
                display: none;
            }
        }
    }
    ul.hot-recommend {
        padding: 0 10px;

        &::after {
            content: "";
            display: block;
            clear: both;
        }
        & > li {
            width: 45%;
            border-radius: 15px;
            margin: 5px 5px;
            font-size: 14px;
            color: #666;
            float: left;
            .van-icon {
                margin-right: 3px;
            }
        }
    }
}
</style>
